import React from "react";
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Box, Typography, Avatar, IconButton, Button, CircularProgress, Alert,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import BlockIcon from "@mui/icons-material/Block";
import CloseIcon from "@mui/icons-material/Close";

const DeleteRewardDialog = ({
    open,
    reward,
    onClose,
    onConfirm,
    onDeactivate,
    deleting,
    deactivating,
    deleteError,
}) => {
    if (!reward) return null;
    const showDeactivate = Boolean(deleteError) || reward.recommended_action === "deactivate";

    return (
        <Dialog open={open} onClose={deleting || deactivating ? undefined : onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
            <DialogTitle sx={{ borderBottom: "2px solid #f1f3f5", px: 3, py: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Box display="flex" alignItems="center" gap={1}>
                    <Avatar sx={{ width: 32, height: 32, bgcolor: "#fef2f2" }}>
                        <DeleteIcon sx={{ fontSize: 18, color: "#DC2626" }} />
                    </Avatar>
                    <Typography variant="h6" fontFamily="Montserrat, sans-serif" fontWeight={700} color="#1a1a2e" fontSize={16}>
                        Supprimer la Récompense
                    </Typography>
                </Box>
                <IconButton onClick={onClose} size="small" disabled={deleting || deactivating}><CloseIcon /></IconButton>
            </DialogTitle>

            <DialogContent sx={{ pt: "24px !important", px: 3, pb: 2 }}>
                {deleteError ? (
                    <Alert severity="warning" sx={{ borderRadius: 2, mb: 2 }}>
                        {deleteError}
                    </Alert>
                ) : (
                    <Box display="flex" alignItems="flex-start" gap={1.5} px={2} py={1.5}
                        sx={{ borderRadius: 2, bgcolor: "#fef2f2", border: "1px solid #fecaca" }}>
                        <DeleteIcon sx={{ color: "#DC2626", fontSize: 20, mt: 0.25, flexShrink: 0 }} />
                        <Box>
                            <Typography fontSize={14} fontWeight={600} color="#991B1B" mb={0.5}>Cette action est irréversible.</Typography>
                            <Typography fontSize={13} color="#7f1d1d">
                                Vous êtes sur le point de supprimer la récompense{" "}
                                <strong>"{reward.name}"</strong>.
                            </Typography>
                        </Box>
                    </Box>
                )}
                {showDeactivate && !deleteError && (
                    <Typography fontSize={12} color="#7f1d1d" mt={1.5}>
                        Des attributions client existent — préférez la désactivation.
                    </Typography>
                )}
            </DialogContent>

            <DialogActions sx={{ px: 3, py: 2, borderTop: "1px solid #e0e0e0", gap: 1, flexWrap: "wrap" }}>
                <Button onClick={onClose} disabled={deleting || deactivating} sx={{ color: "text.secondary", textTransform: "none" }}>
                    {deleteError ? "Fermer" : "Annuler"}
                </Button>
                {showDeactivate && onDeactivate && (
                    <Button
                        variant="outlined"
                        onClick={onDeactivate}
                        disabled={deleting || deactivating}
                        startIcon={deactivating ? <CircularProgress size={16} /> : <BlockIcon />}
                        sx={{ textTransform: "none", borderRadius: 2, fontWeight: 600 }}
                    >
                        {deactivating ? "Désactivation…" : "Désactiver"}
                    </Button>
                )}
                {!deleteError && (
                    <Button variant="contained" onClick={onConfirm} disabled={deleting || deactivating}
                        startIcon={deleting ? <CircularProgress size={16} color="inherit" /> : <DeleteIcon />}
                        sx={{ bgcolor: "#DC2626", "&:hover": { bgcolor: "#b91c1c" }, textTransform: "none", borderRadius: 2, fontWeight: 600, px: 3 }}>
                        {deleting ? "Suppression..." : "Oui, supprimer"}
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default DeleteRewardDialog;
